$(document).ready(() => {
  if ((!$('html').hasClass('page-corporate_gifts') && !$('html').hasClass('page-bulk_order_landing_page')) || window.corporateOnFormUpdate) return;

  // Start Landing: instagram articles
  $('.article-instagram-tab-item').click(function() {
    const $this = $(this);
    const target = $this.data('target');
  
    $('.article-instagram-tab-item').removeClass('active');
    $this.addClass('active');
    
    showInstagramTabContent(target);
  });

  $('[data-article-instagram-select]').change(function(e) {
    const { value } = e.target;
  
    showInstagramTabContent(value);
  });

  function showInstagramTabContent(target) {
    $('.article-instagram-images-content').removeClass('active');
    $(`.article-instagram-images-content[data-content-for="${target}"]`).addClass('active');
  }
  // End Landing: instagram articles
  if (!$('html').hasClass('page-corporate_gifts')) return;

  const minNumberOfBundles = 2
  const maxNumberOfBundles = 1000000
  const minNumberOfCapsules = 2
  const maxNumberOfCapsules = 6
  const minMOQForCustomColor = 5000
  const minMOQForCustomImage = 100
  const capsulesInBox = 6;
  const buttonTextIfNotValid = "Checkout Now"
  const buttonTextIfNeedApprove = "Checkout Now"
  const buttonTextAddToCart = "Add to cart"
  const buttonTextUpdateItem = "Update"
  const possibleCasesValues = [6, 12]
  const orderTypes = {
    STANDARD: 'standard',
    CUSTOM: 'custom',
    INNOTECH_CUSTOM: 'innotechCustom',
  }
  const ctaOnConfirm = "We will contact you within 1 business day to confirm"
  let isEdit = false
  let keyOfEdit = 0


  function createLabelsPreview () {
    const labelArray = [...Array(maxNumberOfCapsules).keys()].map(elem => `<span class="label-${elem+1}"></span>`).join('');
    const labelsMain = `<div class="build-your-${maxNumberOfCapsules}-labels-main corporate-gifting-labels-preview">${labelArray}</div>`;
    $($('.corporate-gifting-preview .preview')[0]).append(labelsMain);
  }
  createLabelsPreview()

  $('.add-to-cart').text(buttonTextIfNotValid)

  $('.btn-continue-building').click((e) => {
    $('.modal__close').click()
  })

  $('.js-modal-open-cant-place-order, .js-modal-open-moq-error, .js-modal-open-moq-error-color, .js-modal-open-save-order').click(() => {
    const thankBlock = $('.thank-block')
    thankBlock.hide()
    thankBlock.prev().show()
    thankBlock.parent().find('.input-full').val('')
    $('.btn-cant-place-order, .btn-moq-error, .btn-moq-error-color, .btn-save-order').each((i, el) => $(el).text($(el).data('text')).removeClass('disabled'))
  })

  $('.btn-email-quote').click(() => {
    if (formIsValid())
      $('.js-modal-open-save-order').click()
    else
      $('.js-modal-open-cant-place-order').click()
  })

  $('#cant-place-order-form, #moq-error-form, #moq-error-color-form, #save-order-form').submit(sendToEmail)

  $("#customNotesSelect").selectize({
    onChange: function (val) {
      const noteEl = $('#customNotes')
      const isTrue = val === 'yes'
      noteEl.toggle(isTrue)
      noteEl.val(isTrue ? noteEl.val() : '')
    },
  })

  $('.product-single__meta .expand-wrapper input, .product-single__meta .expand-wrapper select, .product-single__meta .expand-wrapper textarea').change(onFormUpdate)
  $('.product-single__meta .expand-wrapper select').change(nextTabIfLabelsFilled)
  $('.deliveryDate').change((e) => {
    const datePickerEl = $('.deliveryDate')
    const value = datePickerEl.datetimepicker('getValue')
    datePickerEl.data('date', new Date(value))
    const dateString = value.toLocaleDateString("en-US", {year: 'numeric', month: 'long', day: 'numeric' });
    $(e.target).closest('.expand-wrapper').find('.expand-value').html(` — ${dateString}`)
    $('.review-estimated-delivery-date').text(dateString)
    if ($(e.target).closest('.expand-wrapper').hasClass('disabled')) return
    closePrevExpand(e.target);
    openNextExpand($(e.target))
  })
  $('.corporate-counter .button-minus').click((e) => (closePrevExpand(e.target) && counterChange(e, -1)))
  $('.corporate-counter .button-plus').click((e) => (closePrevExpand(e.target) && counterChange(e, 1)))
  $('.expand-wrapper.select-labels').click((e) => closePrevExpand($(e.target).closest('.expand-wrapper').parent()))

  $('.select-bundle-option').click((e) => {
    closePrevExpand($(e.target).closest('.expand-wrapper').parent());
    $('.select-bundle-option').removeClass('active')
    const option = $(e.target).closest('.select-bundle-option').clone()
    const optionValue = Number(option.data('size'))
    const presetLabels = option.data('preset_labels')
    const outerHTML = $('<div>').append(option).html();
    $(e.target).closest('.select-bundle-option').addClass('active')
    $('.select-bundle .option-name').html(outerHTML)
    $('.select-bundle > .expand-trigger.active').click()

    if (presetLabels) {
      const labels = presetLabels.split(',')
      $('.select-labels .build-18-labels-container select').each((i, el) => {
        if (i >= labels.length) return

        $(el).data('selectize').setValue(labels[i])
      })
    }
    if (!optionValue) {
      $('.corporate-counter-bundle').css('display', 'flex')
      $('.corporate-counter-bundle input').val(minNumberOfBundles).change().trigger('input')
      return 
    }

    $('.corporate-counter-bundle').hide()
    $('.corporate-counter-bundle input').val(optionValue).change().trigger('input')
  })

  $('#numberOfCasules').on('input', (e) => counterInputHandler(e, 'per bundle', true))
  $('#numberOfBundles').on('input', (e) => counterInputHandler(e, 'people'))

  $('#numberOfBundles').change((e) => {
    const val = Number($(e.target).val())
    const newVal = permittedBundlesValue(val)
    if (newVal !== val)
      $(e.target).val(newVal).change().trigger('input')
  });

  $('#numberOfCasules').change((e) => {
    const val = $(e.target).val()
    const newVal = permittedCapsulesValue(val)
    if (newVal !== val) {
        $(e.target).val(newVal)
    }
    const show = (selector) => {
      const capsules = $(selector).toArray()
      $(selector).hide()
      for (let i = 0; i < newVal; i++) {
        $(capsules[i]).show()
      }
    }
    show('.color-wrapper')
    show('.label-wrapper')
    $(e.target).val(newVal).trigger('input')
  });

  function counterInputHandler(e, counterText, indicateMinimum = false) {
    const value = Number($(e.target).val()) || 0
    const isMinimal = value <= minNumberOfCapsules && indicateMinimum
    const expandValue = $(e.target).closest('.expand-wrapper').find('.expand-value')
    if (!value) return $(e.target).fadeTo( 0, 1 ) && expandValue.html('');

    $(e.target).fadeTo(0, 0);
    $(e.target).next().html(`${value} ${counterText} ${isMinimal ? '(minimum)' : ''}`)
    expandValue.html(`: ${value} ${counterText}`)
    updateCapsulesPrice()
    let nextExpand = openNextExpand($(e.target))
    if (indicateMinimum) {
      nextExpand = openNextExpand(nextExpand)
      if (value > 2) {
        $('.product-single__meta')
        .find('.expand-wrapper.disabled')
        .removeClass('disabled')
        .find('.expand-trigger')
        .addClass('active')
        .next()
        .slideDown(500)
      }
    }
    changePreview()
    $('[data-build-selectize]').eq(0).data('selectize').trigger('change')
  }
  
  function permittedCapsulesValue(value) {
    const val = Number(value) || 0
    if (val > maxNumberOfCapsules) return maxNumberOfCapsules
    if (val < minNumberOfCapsules) return minNumberOfCapsules
    return val
  }
  
  function permittedBundlesValue(value) {
    const val = Number(value) || 0
    if (val > maxNumberOfBundles) return maxNumberOfBundles
    if (val < minNumberOfBundles) return minNumberOfBundles
    return val
  }
  
  function counterChange(e, val) {
    const input = $(e.target).parent().find('input')
    input.val(Number(input.val() || 0) + val).change().trigger('input')
  }

  $(".custom-image-input-wrapper input").change((e) => {
    const picture = e.target.files[0];
    const formData = new FormData();
    if (!picture) return

    formData.append("file", picture);
    fetch(`${backend_url}/api/upload_file`, {method: "POST", body: formData })
      .then((response) => response.json())
      .then((res) => {
        $(e.target).parent().find('.name').text(picture.name)
        $(e.target).attr('data-url', res.data.url)
        onFormUpdate()
        submitButtonUpdate()
        $(e.target).closest('.label-wrapper').find('[data-build-selectize]').data('selectize').trigger('change')
      });
  })

  function openNextExpand(el) {
    const $el = $(el).closest('.expand-wrapper').next().find('.expand-trigger').eq(0)
    
    const wrapper = $el.closest('.expand-wrapper');
    wrapper.removeClass('disabled')

    $el.addClass('active');
    $el.next().slideDown(500)
    return $el
  }

  function closePrevExpand(el) {
    const $el = $(el).closest('.expand-wrapper').prev().find('.expand-trigger').eq(0)
    
    const wrapper = $el.closest('.expand-wrapper');
    if (wrapper.hasClass('disabled')) return;

    $el.removeClass('active');
    $el.next().slideUp(500)
    return $el
  }

  function nextTabIfLabelsFilled(e) {
    if (labelsIsFilled()) {
      nextExpand = openNextExpand($(e.target).closest('.corporate-labels'))
      openNextExpand(nextExpand)
    }
  }

  function labelsIsFilled() {
    const numberOfCasules = Number($('#numberOfCasules').val())
    return numberOfCasules && !$('.color-wrapper').toArray().find((el, i) => {
      if (i >= numberOfCasules) return false
      
      return !$('.label-wrapper').eq(i).find('.premade-labels [data-build-selectize]').val();
    })
  }

  function setCalendar(date) {
    $('.deliveryDate').datetimepicker({
      timepicker: false,
      format: 'd.m.Y',
      inline: true,
      scrollMonth : false,
      minDate: date,
    });
    $('.corporate-number-of-people-expand').removeClass('disabled')
  }
  setCalendar(new Date)

  async function sendToEmail(e) {
    e.preventDefault()
    const button = $(e.currentTarget).find('button')
    const loadingText = 'Loading...'
    if (button.hasClass('disabled')) return

    $('.btn-cant-place-order, .btn-moq-error, .btn-moq-error-color, .btn-save-order').each((i, el) => $(el).data('text', $(el).text()).addClass('disabled').text(loadingText))
    const data = collectData()
    data['Preview URL'] = await getPreviewUrl()
    fetch(`${backend_url}/api/corporate_gifting`, {method: "POST", body: JSON.stringify(data)});
    $(e.target).closest('.modal__centered').hide().next().show()
    $('.corporate-cta').html(ctaOnConfirm)
  }
  // Add to Cart
  $('.add-to-cart').click(async () => {
    if (!formIsValid()) return
    if (!canPlaceOrder()) return $('.js-modal-open-cant-place-order').click()
    if ($('.add-to-cart').hasClass('disabled')) return
    await $.post('/cart/clear.js')

    numberOfBundles = Number($('#numberOfBundles').val())
    $('.add-to-cart').addClass('disabled')
    const id = $('[data-product-select]').val()
    mainData = {
      items: [
        {
          id: corporate_gifting_main_id,
          quantity: numberOfBundles,
          properties: getPropertiesAll()
        }
      ]
    }
    const items = mainData.items
    const timestamp = mainData.items[0].properties['Timestamp']
    calculatePrice()
    const packInBoxes = $('.packing-type').is(':checked')
    const customInsertFilled = $('#customNotes').val()?.length
    
    const numberOfCasules = $('#numberOfCasules').val()
    for (let i = 0; i < numberOfCasules; i++) {
      const label =  $('.label-wrapper').eq(i).find('.premade-labels [data-build-selectize]').val();
      const color = $('.color-wrapper').eq(i).find('.one-half [data-build-selectize]').val()
      const colorType = color == 'Custom color' ? 'custom' : 'standard'
      const type = label === 'customize' || isArakiIcon(label) ? 'custom' : isCustomImage(label) ? 'custom_image' : 'standard'
      const customLabel = $('.label-wrapper').eq(i).find('.custom-label').val()

      $('[data-product-select] option').toArray().find((option) => {
        curOptionText = $(option).text()
        findOptionText = `${colorType} / ${type}`
        if (curOptionText.includes(findOptionText)) {
          const id = $(option).val()
          const properties = getPropertiesSingle($('.color-wrapper').eq(i), timestamp)
          const item = items.find((i) => i.id === id && JSON.stringify(i.properties) === JSON.stringify(properties))
          if (item) {
            item.quantity += numberOfBundles
            item.properties['Quantity'] += 1
          }
          else
            items.push({
              id,
              quantity: numberOfBundles,
              properties
            })
          return true
        }
      })
      addShadowProducts(items, color, label, customLabel, numberOfBundles, timestamp)
    }

    if (packInBoxes) {
      const numberOfCasules = $('#numberOfCasules').val()
      const quantityBox = Math.ceil(numberOfCasules / capsulesInBox)
      items.push({
        id: corporate_gifting_box_id,
        quantity: quantityBox * numberOfBundles,
        properties: getPropertiesSingle($('.color-wrapper').eq(0), timestamp)
      })
      
    }

    if (customInsertFilled) {
      const option = getVariant(['Custom Insert', 'Custom Insert'])
      if (option) {
        const props = {
          "Quantity": 1,
          "Parent Timestamp": timestamp
        }
        items.push({
          id: $(option).val(),
          quantity: numberOfBundles,
          properties: props
        })
      }
    }
    $('.corporate-cta').html(ctaOnConfirm)
    const resData = await $.post('/cart/add.js', mainData)
    if (isEdit) {
      await theme.cart.changeItem(keyOfEdit, 0)
      updateAddToCartButton()
      keyOfEdit = JSON.parse(resData).items[0].key
      return
    }
    $.get('/cart.js').then(res => {
      $('body').trigger('updateCart', res)
      $('.add-to-cart').removeClass('disabled')
    });
  })

  
  function addShadowProducts(items, color, label, customLabel, quantity, timestamp) {
      properties = {
        'Product': "corporate_gifting",
        'Color': color,
        'Label': label,
        'Custom Label': customLabel,
        'Quantity': 1,
        'Parent Timestamp': timestamp,
      }
      const shadowCapsuleid = getShadowProduct('capsule', color, defaulf_size.toLowerCase())?.id
      const item = {id: shadowCapsuleid, quantity, properties}
      const existingItem = existingShadowProductItem(item, items)
      if (existingItem) {
        existingItem.quantity += quantity
        existingItem.properties['Quantity'] += 1
      } else 
        items.push(item)
  }

  function submitButtonUpdate() {
    if (!labelsIsFilled()) return $('.add-to-cart').attr('disabled', true)
    if (!formIsValid()) return $('.add-to-cart').text(buttonTextIfNotValid)
    if (!canPlaceOrder()) return $('.add-to-cart').text(buttonTextIfNeedApprove).attr('disabled', false).removeClass('disabled')
    $('.add-to-cart').text(isEdit ? buttonTextUpdateItem : buttonTextAddToCart).attr('disabled', false).removeClass('disabled')
  }

  function formIsValid() {
    const numberOfCasules = Number($('#numberOfCasules').val())
    const numberOfBundles = Number($('#numberOfBundles').val())
    return !$('.color-wrapper').toArray().find((el, i) => {
      if (i >= numberOfCasules) return false

      const label = $('.label-wrapper').eq(i).find('.premade-labels [data-build-selectize]').val();
      const color = $(el).find('.one-half [data-build-selectize]').val()
      const isCustomColor = color === 'Custom color'
      const customColor = $(el).find('.custom-color').val()
      const customImage = $('.label-wrapper').eq(i).find('.custom-label-image').attr('data-url')
      const MOQ = numberOfBundles * numberOfCasules

      if (MOQ < minNumberOfCapsules * minNumberOfBundles) return true
      if (!label || !color) return true
      if (isCustomImage(label) && !customImage) return true
      if (isCustomColor && !customColor) return true
      if (isCustomColor && numberOfBundles < minMOQForCustomColor) return true
    })
  }

  function getPropertiesSingle (el, timestamp) {
    data = {}
    const { label, customizeLabel, color } = getPropertiesHelper(el)
    numberOfBundles = Number($('#numberOfBundles').val())
    data[`Standard Bundle Label`] = label
    data[`Custom Bundle Label`] = customizeLabel
    data[`Bundle Color`] = color
    data[`Quantity`] = 1
    data[`Parent Timestamp`] = timestamp
    return data
  }

  function getPropertiesHelper(el) {
    const index = Number($(el).data('index'))
    const label = $('.label-wrapper').eq(index).find('.premade-labels [data-build-selectize]').val();
    const color = $(el).find('.one-half [data-build-selectize]').val()
    const isCustomize = $('.label-wrapper').eq(index).find('.item.user-created-tag').length || isArakiIcon(label)
    return { isCustomize, label: isCustomize ? 'customize' : label, customizeLabel: isCustomize ? label : '', color }
  }

  function getPropertiesAll() {
    data = {}
    const items = $('.color-wrapper')
    const numberOfCasules = $('#numberOfCasules').val()
    data[`Timestamp`] = Date.now()
    data[`URL For Edit`] = `${window.location.href.split('?')[0]}?&isEdit=true&${$.param( collectData() )}`
    items.map((index, el) => {
      if (index >= numberOfCasules) return false
      const { label, customizeLabel, color } = getPropertiesHelper(el)
      data[`Custom Bundle Label ${index + 1}`] = customizeLabel
      data[`Bundle Color ${index + 1}`] = color
      data[`Standard Bundle Label ${index + 1}`] = label
    })
    data = {...collectData(), ...data}
    delete data['Items']
    return data
  }
  
  function calculatePrice() {
    let price = 0
    const numberOfBundles = $('#numberOfBundles').val()
    const numberOfCasules = $('#numberOfCasules').val()
    for (let i = 0; i < numberOfCasules; i++) {
      const label = $('.label-wrapper').eq(i).find('.premade-labels [data-build-selectize]').val();
      const isCustomize = $('.label-wrapper').eq(i).find('.item.user-created-tag').length || isArakiIcon(label)
      const color = $('.color-wrapper').eq(i).find('.one-half [data-build-selectize]').val()
      const colorType = color == 'Custom color' ? 'custom' : 'standard'
      const type = isCustomize ? 'custom' : isCustomImage(label) ? 'custom_image' : 'standard'
      const boxPrice = getVariantPrice([colorType, type])
      if (boxPrice)
        price += boxPrice;
      else
        $('.add-to-cart').addClass('disabled')
    }

    price = price * numberOfBundles
    price += Number($('.review-custom-insert-cost').text())
    price += Number($('.review-packaging-cost').text())
    $('.review-subtotal').text(price)
    return price
  }

  $('#numberOfBundles, #numberOfCasules').change(() => {
    const numberOfBundles = Number($('#numberOfBundles').val())

    $(".custom-color").prop( "disabled", numberOfBundles < minMOQForCustomColor );
  })

  function canPlaceOrder(checkDelivery = true) {
    const items = $('.color-wrapper')
    const deliveryIsReal = deliveryDateIsReal()
    const numberOfCasules = Number($('#numberOfCasules').val())

    return numberOfCasules && !items.filter((i, item) => {
      if (i >= numberOfCasules) return false
      const {color, label} = getPropertiesHelper(item)
      if (isCustomImage(label) || color == 'Custom color')
        return item
    }).length && (checkDelivery ? deliveryIsReal : true)
  }

  function deliveryDateIsReal() {
    const numberOfBundles = Number($('#numberOfBundles').val())
    const numberOfCasules = Number($('#numberOfCasules').val())
    const MOQ = numberOfBundles * numberOfCasules
    const date = $('.deliveryDate').data('date')
    const milli_secs = new Date(date).getTime() - new Date().getTime();
    const type = orderType()
     
    const days = Math.round(milli_secs / (1000 * 3600 * 24));
    if (days <= 0) return false

    if (type === orderTypes.INNOTECH_CUSTOM) {
      if (MOQ < 100) return false
      if (MOQ < 500 && days < 20) return false
    }

    if (MOQ < 250 && days > 0) return true
    if (MOQ >= 250 && days > 10) return true
    if (MOQ >= 600 && days > 30) return true
    if (MOQ >= 1000 && days > 60) return true
    if (MOQ >= 5000 && days > 90) return true
    if (MOQ >= 10000) return false

    return false
  }

  function orderType() {
    let type = orderTypes.STANDARD
    for (let i = 0; i < $('.color-wrapper').length; i++) {
      if (i >= numberOfCasules) continue

      const {isCustomize, label, color} = getPropertiesHelper($('.color-wrapper').eq(i))
      isCustomColor = color === 'Custom color'
      if (isCustomColor || isCustomImage(label)) {
        return orderTypes.INNOTECH_CUSTOM
      }

      if (isCustomize) type = orderTypes.CUSTOM
    }
    return type
  }

  function collectData() {
    const data = {}
    const numberOfCasules = Number($('#numberOfCasules').val())
    const numberOfBundles = Number($('#numberOfBundles').val())
    const customlabelPrice = Number($('.review-custom-label-cost').text())
    const customLogoPrice = Number($('.review-custom-logo-cost').text())
    const packingPrice = Number($('.review-packaging-cost').text())
    const labelsPrice = customlabelPrice + customLogoPrice
    const email = $('#cant-place-order .input-full').val() || $('#moq-error .input-full').val() || $('#moq-error-color .input-full').val() || $('#save-order .input-full').val()
    const defaultPriceValue  = "Free"
    if (email) data['Email'] = email
    data['Number of Bundles'] = numberOfBundles
    data['Pack In Boxes'] = $('.packing-type').is(':checked')
    data['Packing Price'] = packingPrice || defaultPriceValue
    data['Price'] = calculatePrice()
    data['Custom Insert'] = $('#customNotes').val()
    data['Delivery Date'] = $('.deliveryDate').data('date').toLocaleDateString('en-US');
    data['Units Count'] = numberOfBundles * numberOfCasules
    data['Unit Price'] = `$${$('.review-capsules-cost').text() / numberOfBundles}`
    data['Labels Price'] = labelsPrice > 0 ?`$${labelsPrice}` : defaultPriceValue
    data['Colors Price'] = defaultPriceValue
    data['Items'] = []
    $('.color-wrapper').map((i, el) => {
      if (i >= numberOfCasules) return
      const {isCustomize, label, customizeLabel, color} = getPropertiesHelper(el)
      const customColor = $(el).find('.custom-color').val()
      const isCustomColor = color === 'Custom color'

      const labelIsCustomImage = isCustomImage(label)

      const customImage = $('.label-wrapper').eq(i).find('.custom-label-image').attr('data-url')
      const imageUrl = `${customImage}`
      const item = {}
      item['Is Custom Color'] = isCustomColor
      item['Is Custom Logo'] = labelIsCustomImage
      item['Is Custom Label'] = isCustomize
      item['Label'] = isCustomize && !labelIsCustomImage ? customizeLabel : labelIsCustomImage ? imageUrl : label
      item['Color'] = isCustomColor ? customColor : color
      item['Index'] = i + 1
      data['Items'].push(item)
    })
    return data
  }

  async function getPreviewUrl() {
    const previewEl = $(".preview")[0]
    const canvas = await html2canvas(previewEl, {
      allowTaint: true,
      height: 600,
      y: 100,
      width: previewEl.clientWidth - 2,
      x: 1,
      backgroundColor: null
    })
    const image_c = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
    const blob = dataURItoBlob(image_c)

    const formData = new FormData();
    formData.append("file", blob);
    const image = await fetch(`${backend_url}/api/upload_file`, {method: "POST", body: formData }).then(function(response) {
      return response.json();
    })
    return image.data.url
  }

  function onFormUpdate() {
    const hasCustomLogo = $('.corporate-labels [data-labelmessage]').toArray().find((el) => $(el).attr('data-labelmessage') === "Select image")
    const textElForCustomLogo = $('.corporate-labels > .textarea-wrapper > i')
    if (hasCustomLogo)
      textElForCustomLogo.show()
    else
      textElForCustomLogo.hide()

    updateCapsulesPrice()
    updateCustomLabelPrice()
    updateCustomLogoPrice()
    updateCustomInsertPrice()
    updatePackingPrice()
    updateEstimatedDeliveryTime()
    calculatePrice()
    submitButtonUpdate()
    changePreview()
  }
  window.corporateOnFormUpdate = onFormUpdate
  onFormUpdate()

  function changePreview() {
    const numberOfCasules = Number($('#numberOfCasules').val())
    const capsulesColor = []
    const labelsPreviewCount = possibleCasesValues.find((el) => el >= numberOfCasules)

    $('.corporate-gifting-labels-preview').attr('class', `build-your-${labelsPreviewCount}-labels-main corporate-gifting-labels-preview`)
    $('.corporate-gifting-labels-preview').attr('data-capsules', numberOfCasules)
    $('.corporate-gifting-labels-preview > span').hide()
    for (let i = 0; i < numberOfCasules; i++) {
      let index = i
      const color = $('.color-wrapper').eq(i).find('.one-half [data-build-selectize]').val()
      capsulesColor.push(bundleColorValues.indexOf(color) + 1)

      if (numberOfCasules === 2)
        index += 1
      if (numberOfCasules === 4 && index >= 3)
        index += 1
      if (numberOfCasules === 5) {
        index += 1
      }
      $('.corporate-gifting-labels-preview > span').eq(index).show()
    }

    if (!capsulesColor.length) return
    if (capsulesColor.length === 2) {
      capsulesColor.splice(0, 0, 0);
    }
    if (capsulesColor.length === 4) {
      capsulesColor.splice(3, 0, 0);
      capsulesColor.push(0)
    }
    if (capsulesColor.length === 5) {
      capsulesColor.unshift(0)
    }

    $('.imageFromService').attr('src', `${image_service_url}/api/image?type=build&capsules=${capsulesColor.join(',')}&device=mobile&is_corporate=true&source=corporate`)
  }

  function updateEstimatedDeliveryTime() {
    const estimate = getEstimatedDeliveryTime()
    if (!estimate) return

    const datepickerValue = $('.deliveryDate').datetimepicker('getValue').setUTCHours(0,0,0,0);
    const date = new Date();
    date.setDate(date.getDate() + estimate.max_days);
    $('.deliveryDate').datetimepicker('setOptions', {minDate: date})
    if (datepickerValue < date.setUTCHours(0,0,0,0)) {
      $('.deliveryDate').datetimepicker('setOptions', {value: date})
      $('.deliveryDate').change()
    }

    $('.review-delivery-date').text(estimate.text)
  }

  function getEstimatedDeliveryTime() {
    const numberOfBundles = Number($('#numberOfBundles').val())
    const numberOfCasules = Number($('#numberOfCasules').val())
    const MOQ = numberOfBundles * numberOfCasules
    const type = orderType()

    if (type === orderTypes.INNOTECH_CUSTOM) {
      if (MOQ > 600 && MOQ <= 5000) return {text: '3-5 weeks', min_days: 21, max_days: 35}
      if (MOQ > 5000 && MOQ < 10000) return {text: '5-8 weeks', min_days: 35, max_days: 56}
    }

    if (MOQ <= 250) return {text: '1-2 weeks', min_days: 7, max_days: 14}
    if (MOQ <= 600) return {text: '1-3 weeks', min_days: 7, max_days: 21}
    if (MOQ <= 5000) return {text: '2-4 weeks', min_days: 14, max_days: 28}
    if (MOQ <= 10000) return {text: '4-8 weeks', min_days: 28, max_days: 56}
    return {text: 'we need to quote', min_days: 0, max_days: 0}
  }

  function updateCapsulesPrice() {
    const capsulesPerBundle = $('#numberOfCasules').val()
    const numberOfBundles = $('#numberOfBundles').val()
    const capsulesTotal = capsulesPerBundle * numberOfBundles
    const cost = getVariantPrice(['standard', 'standard']) * capsulesTotal
    $('.review-capsule-per-bundle-count').text(capsulesPerBundle)
    $('.review-bundles-count').text(numberOfBundles)
    $('.review-capsule-count').text(capsulesTotal)
    $('.review-capsules-cost').text(cost)
    $('.review-capsules-cost').closest('li').toggle(!!cost)
  }

  function updateCustomLabelPrice() {
    const {customLabelCount, cost} = getLabelCountAndCost("customize", ['standard', 'custom_text'])
    const count = cost ? ` x ${customLabelCount}` : ''
    updateReviewLine('review-custom-label', count, cost, !!cost)
  }

  function updateCustomLogoPrice() {
    const {customLabelCount, cost} = getLabelCountAndCost("Custom Logo", ['standard', 'custom_image'])
    const count = cost ? ` x ${customLabelCount}` : ''
    updateReviewLine('review-custom-logo', count, cost, !!cost)
  }

  function getLabelCountAndCost(labelVal, options) {
    const numberOfBundles = $('#numberOfBundles').val()
    const customLabelCount = $('.label-wrapper:visible [data-build-selectize]').toArray().filter((el) => $(el).val().includes(labelVal)).length
    const cost = (getVariantPrice(options) - getVariantPrice(['standard', 'standard'])) * customLabelCount * numberOfBundles
    return {customLabelCount, cost}
  }

  function updateCustomInsertPrice() {
    const numberOfBundles = $('#numberOfBundles').val()
    const customInsertFilled = $('#customNotes').val()?.length
    const cost = getVariantPrice(['Custom Insert', 'Custom Insert']) * numberOfBundles
    updateReviewLine('review-custom-insert', 0, customInsertFilled ? cost : 0, !!customInsertFilled)    
  }

  function updatePackingPrice() {
    $('.review-packaging-cost').text(0)
    if ($('.packing-type').is(':checked')) {
      const numberOfBundles = $('#numberOfBundles').val()
      const numberOfCasules = $('#numberOfCasules').val()
      const quantity = Math.ceil(numberOfCasules / capsulesInBox)
      const boxPrice = getVariantPrice(['box', 'box'])
      const packingPrice = boxPrice * quantity
      const cost = packingPrice * numberOfBundles
      $('.review-packaging-cost').text(cost)
    }
    $('.review-packaging-cost').closest('li').toggle(!!Number($('.review-packaging-cost').text()))
  }

  function updateReviewLine(classPrefix, count, cost, visible) {
    $(`.${classPrefix}-count`).text(count)
    $(`.${classPrefix}-cost`).text(cost)
    $(`.${classPrefix}-cost`).closest('li').toggle(!!visible)
  }

  function getVariantPrice(arrayOfOptions) {
    const variant = getVariant(arrayOfOptions)
    if (!variant) return false
    $(variant).text()
    const variantPrice = curOptionText.match(/\$(.*?)USD/)
    return Number(variantPrice[1])
  }

  function getVariant(arrayOfOptions) {
    const variant = $('[data-product-select] option').toArray().find((option) => {
      curOptionText = $(option).text()
      findOptionText = arrayOfOptions.join(' / ')
      return curOptionText.includes(findOptionText)
    })
    return variant
  }

  window.isValidMOQ = () => {
    const numberOfBundles = Number($('#numberOfBundles').val())
    return {color: numberOfBundles >= minMOQForCustomColor, label: numberOfBundles >= minMOQForCustomImage}
  }

  saveSelectionToUrl = () => {
    return `${window.location.href.split('?')[0]}?${$.param( collectData() )}`
  }

  function loadSelectionsFromUrl() {
    const data = deparam(window.location.href)
    Object.keys(data).forEach(key => data[key.replace('amp;', '')] = data[key])
    const date = data['Delivery Date']
    if (!date) return

    if (data['isEdit']) {
      isEdit = true
      keyOfEdit = data['item_key']
      $('.add-to-cart').text(buttonTextUpdateItem)
    }

    $('#numberOfBundles').val(data['Units Count'] / data['Items'].length).change()

    $('.select-bundle-option[data-size="0"]').click()
    $('#numberOfCasules').val(data['Items'].length).change()

    data['Items'].forEach((el, i) => {
      const index = i + 1

      const color = el['Is Custom Color'] === "true" ? 'Custom color' : el['Color']
      $(`.corporate-colors [data-product-index="${index}"]`).data('selectize').setValue(color)
      if (el['Is Custom Color']) {
        $(`.corporate-colors .color-wrapper[data-index="${index - 1}"] .custom-color`).val(el['Color'])
      }

      const labelSelectize = $(`.corporate-labels .hex-container-${index} [data-build-selectize]`).data('selectize')
      let label = el['Is Custom Label'] === "true" ? 'customize' : el['Label']
      if (el['Is Custom Logo'] === "true") {
        label = Object.keys(labelSelectize.options).find((key) => labelSelectize.options[key].text === 'Select image')
        $(`.corporate-labels .hex-container-${index} .custom-label-image`).attr('data-url', el['Label'])
      }
      $(`.corporate-labels .hex-container-${index} [data-build-selectize]`).data('selectize').setValue(label)
      if (el['Is Custom Label']) {
        $(`.corporate-labels .hex-container-${index} .custom-label`).val(el['Label']).change().trigger('input')
      }
    })

    if (data['Pack In Boxes'] === "true") {
      $('.packing-type').prop('checked', true)
    }
    
    $('#customNotes').val(data['Custom Insert'])
    $('.deliveryDate').datetimepicker('setOptions', {value: new Date(new Date(date))})
  }
  loadSelectionsFromUrl()
})


const TempImage = window.Image
  
const Image = function() {
  const img = new TempImage()
  img.crossOrigin = 'anonymous'
  return img
}